// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge[data-v-1b3ae29b] {\n  --magic-badge-background: #452970;\n}\n\n.categories-menu[data-v-1b3ae29b] {\n  width: auto;\n}", ""]);
// Exports
module.exports = exports;
